import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-027b1bbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "success-container inner" }
const _hoisted_3 = { class: "account-manage" }
const _hoisted_4 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "simple-spinner" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "password_heading_text_success" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("article", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "success-icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "text" })
], -1))
const _hoisted_10 = { class: "introduction" }

import { ref, onMounted, computed } from "vue";
import LanguageDropdown from "./LanguageDropdown.vue";
import Logo from "./logo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessMessage',
  setup(__props) {

const languageList = ref<any[]>([]);
const userLang = ref(localStorage.getItem("userLang") || "EN");
const headingObj = ref<any>(null);
const messageObj = ref<any>(null);
const loading = ref(true);

// Computed: Heading translation
const translatedHeading = computed(() => {
  if (!headingObj.value) return "";

  const selectedLang = languageList.value.find(lang => lang.key === userLang.value);
  const selectedLangId = selectedLang?._id;

  const translation = headingObj.value.translate.find(
    (t: any) => t.languageId === selectedLangId && t.isPublished
  );

  return translation?.value || headingObj.value.base;
});

// Computed: Message translation
const translatedMessage = computed(() => {
  if (!messageObj.value) return "";

  const selectedLang = languageList.value.find(lang => lang.key === userLang.value);
  const selectedLangId = selectedLang?._id;

  let translation = messageObj.value.translate.find(
    (t: any) => t.languageId === selectedLangId && t.isPublished
  )?.value;

  if (!translation) translation = messageObj.value.base;

  const identifier = localStorage.getItem("email_for_reset") || "";
  if (identifier) {
    translation = translation.replace(/%this\.user\.identifier%/g, identifier);
  }

  return translation;
});

// Fetch language and translation data
const fetchData = async () => {
  loading.value = true;

  try {
    const translateText = localStorage.getItem("translate_text");
    const successRes = localStorage.getItem("success_res");
    const emailForReset = localStorage.getItem("email_for_reset");

    if (!successRes || !emailForReset) {
      loading.value = false;
      return;
    }

    if (translateText) {
      const parsedData = JSON.parse(translateText);

      languageList.value = parsedData.languageList || [];
      headingObj.value = parsedData.updated_heading_message_text || null;
      messageObj.value = parsedData.updated_message_text || null;
    }
  } catch (err) {
    console.error("Error fetching success page data:", err);
  } finally {
    loading.value = false;
  }
};

// Handle language change
const handleLanguageChange = (lang: string) => {
  userLang.value = lang;

  const storedData = localStorage.getItem("translate_text");
  if (storedData) {
    try {
      const parsedData = JSON.parse(storedData);
      parsedData.userLang = lang; // update userLang in storage
      localStorage.setItem("translate_text", JSON.stringify(parsedData));
    } catch (err) {
      console.error("Failed to update language in localStorage:", err);
    }
  }
};

// Initialize on mount
onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Logo),
      _createVNode(LanguageDropdown, {
        languageList: languageList.value,
        defaultLang: userLang.value,
        onLanguageChanged: handleLanguageChange
      }, null, 8, ["languageList", "defaultLang"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("h1", _hoisted_8, _toDisplayString(translatedHeading.value), 1),
              _hoisted_9,
              _createElementVNode("p", _hoisted_10, _toDisplayString(translatedMessage.value), 1)
            ]))
      ])
    ])
  ], 64))
}
}

})